import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for promotional codes table.
 * @extends JetView
 */
export default class tablePromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define the main view as a datatable
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatable',
            // CSS classes for styling the datatable borders
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Set height based on screen width
            height: screen.width < 500 ? 400 : 0,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing with an icon
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip text for the edit icon
                    tooltip: 'Editar',
                    // Template function to render the edit icon
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close edit'></span>";
                    },
                },
                // Column for ID with integer sorting
                { id: 'Id', header: 'ID', width: 100, sort: 'int' },
                // Column for Code with integer sorting
                { id: 'Code', header: 'Código', width: 250, sort: 'int' },
                {
                    // Column for creation date with localization and formatting
                    id: 'CreatedLocalDate',
                    header: _('Fecha de Creación'),
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat,
                },
                // Column for LinkId with integer sorting
                { id: 'LinkId', header: _('LinkId'), width: 250, sort: 'int' },
                {
                    // Column for activation status with options
                    id: 'IsActivate',
                    header: _('Estado'),
                    options: [
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivo') },
                    ],
                    width: 150,
                    sort: 'int',
                },
            ],
            // Event handler for click on edit icon
            onClick: {
                edit: function (euv, id) {
                    // Show the edit code dialog
                    $$('EditCode').show();
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching configuration
            loadahead: devConfig.getDefaultDataFetch(),
            // Identifier for the pager component
            pager: 'pagerA',
            // API URL for fetching data, including the current user ID
            url: devConfig.geturlApi() + 'es/PromotionalCodes/GetCodes?FromId=' + cur_user + '&',
            // Initial data for the datatable
            data: [
                {
                    // Sample data entry with ID and other attributes
                    Id: '01',
                    Code: '0101',
                    CreatedLocalDate: '2019-02-03',
                    ModifiedLocalDate: '2019-02-06',
                    LinkId: '0105',
                    IsActivate: 'A',
                },
                {
                    // Another sample data entry
                    Id: '02',
                    Code: '0103',
                    CreatedLocalDate: '2019-02-10',
                    ModifiedLocalDate: '2019-02-12',
                    LinkId: '0106',
                    IsActivate: 'A',
                },
            ],
            // Event handler for double-click on an item
            on: {
                onItemDblClick: (id) => {
                    // Show the edit code dialog on double-click
                    $$('EditCode').show();
                },
            },
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Get the current user parameter, required to be present
        const cur_user = this.getParam('user', true);
        // Store the URL for the grid data
        var url = grid.data.url;
        // Initialize an empty filter string
        var filter = '';
        // Listen for the 'promotionalCodes:filter' event on the app
        this.on(this.app, 'promotionalCodes:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            // Initialize an empty string to build the query parameters
            var string1 = '';
            // Iterate over each entry in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle the 'CreatedLocalDate' filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - ');
                        // Append date range to the query string
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Handle the 'ModifiedLocalDate' filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - ');
                            // Append modified date range to the query string
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            // Append other filters to the query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate over the entries of the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle the 'start' date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    // Format the start date for the query string
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle the 'end' date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        // Format the end date for the query string
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the filter string
            string1 = string1 + '&FromId=' + cur_user;
            // Clear the grid data
            grid.clearAll();
            // Load the grid with the new data based on the constructed URL and filter
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the new filter string
            filter = string1;
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Number of items per page
                    filter + // Additional filter parameters
                    '&sort[' +
                    by + // Sort by the specified field
                    ']=' +
                    dir, // Sort direction (ascending or descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item by its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Listen for the 'player:select' event from the app
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid data filtered by the selected player's ID
            grid.load(
                grid.data.url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Number of items per page
                    '&PlayerId=' +
                    Id, // Filter by the selected player's ID
            );
        });
        // Create a popup window for editing promotional codes
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'EditCode', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    { view: 'label', label: _('Editar Código') }, // Label for the window title
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the window
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Form inside the window
                id: 'editForm', // Unique identifier for the form
                elements: [
                    { view: 'text', label: 'ID', name: 'Id', readonly: true }, // Read-only field for ID
                    { view: 'text', label: _('Código'), name: 'Code' }, // Input field for code
                    {
                        view: 'text', // Field for creation date
                        label: _('Fecha de Creación'),
                        labelWidth: 140, // Width of the label
                        name: 'CreatedLocalDate',
                        readonly: true, // Read-only field for creation date
                    },
                    { view: 'text', label: _('LinkId'), name: 'LinkId' }, // Input field for LinkId
                    {
                        view: 'combo', // Dropdown for status
                        label: _('Estado'),
                        name: 'IsActivate',
                        options: [
                            // Options for the dropdown
                            { id: 'A', value: _('Activado') }, // Active option
                            { id: 'I', value: _('Inactivado') }, // Inactive option
                        ],
                    },
                    {
                        cols: [
                            // Button layout in columns
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'), // Button label
                                click: function () {
                                    // Click event for cancel button
                                    this.getTopParentView().hide(); // Hide the window
                                    $$('editForm').setValues(
                                        // Reset form values
                                        $$('editForm').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form', // Button type
                                value: _('Guardar'), // Button label
                                click: function ($e) {
                                    // Click event for save button
                                    var values = $$('editForm').getValues(); // Get form values
                                    webix // AJAX request to update the code
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API URL for update
                                                'PromotionalCodes/UpdateCode',
                                            '{"Id":"' + // JSON payload for the request
                                                values.Id +
                                                '", "Code":"' +
                                                values.Code +
                                                '", "CreatedLocalDate":"' +
                                                values.CreatedLocalDate +
                                                '", "LinkId":"' +
                                                values.LinkId +
                                                '" ,"IsActivate":"' +
                                                values.IsActivate +
                                                '" ,"User":"' +
                                                cur_user +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error callback
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success callback
                                                    webix.message(_('Código Actualizado')); // Show success message
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        // Reload the grid with updated data
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                    );
                                                },
                                            },
                                        );
                                    $$('editForm').setValues(
                                        // Reset form values after save
                                        $$('editForm').getCleanValues(),
                                    );
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Create a local date string in the format YYYY:MM:DD
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2);

        // Initialize a popup window for adding a new code
        var popupAdd = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'AddCode', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Añadir Código') }, // Label for the title
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close',
                        click: function () {
                            // Hide the window when the close icon is clicked
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Define the body as a form
                id: 'addform', // Unique identifier for the form
                elements: [
                    { view: 'text', label: _('Código'), name: 'Code' }, // Input for the code
                    {
                        view: 'text', // Input for the creation date
                        label: _('Fecha de Creación'),
                        labelWidth: 140, // Width of the label
                        name: 'CreatedLocalDate',
                        value: createdLocalDate, // Set the value to the created local date
                        readonly: true, // Make the field read-only
                    },
                    { view: 'text', label: _('LinkId'), name: 'LinkId' }, // Input for the LinkId
                    {
                        view: 'combo', // Dropdown for the status
                        label: _('Estado'),
                        name: 'IsActivate',
                        options: [
                            { id: 'A', value: _('Activado') }, // Option for activated
                            { id: 'I', value: _('Inactivado') }, // Option for deactivated
                        ],
                    },
                    {
                        cols: [
                            // Define a row of buttons
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    // Hide the window and reset the form values
                                    this.getTopParentView().hide();
                                    $$('addform').setValues($$('addform').getCleanValues());
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    // Get form values
                                    var values = $$('addform').getValues();
                                    webix
                                        .ajax() // Perform an AJAX request
                                        .headers({
                                            'Content-type': 'application/json', // Set content type to JSON
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API endpoint for adding a code
                                                'PromotionalCodes/AddCode',
                                            '{"Code":"' +
                                                values.Code +
                                                '", "CreatedLocalDate":"' +
                                                createdLocalDate +
                                                '", "LinkId":"' +
                                                values.LinkId +
                                                '" ,"IsActivate":"' +
                                                values.IsActivate +
                                                '" ,"User":"' +
                                                cur_user +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Handle error response
                                                    webix.message(_('Error! '));
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Handle successful response
                                                    webix.message(_('Código Agregado'));
                                                    grid.clearAll(); // Clear the grid
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload the grid data
                                                    );
                                                },
                                            },
                                        );
                                    // Reset the form values and hide the window
                                    $$('addform').setValues($$('addform').getCleanValues());
                                    this.getTopParentView().hide();
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Listen for the 'addCode:button' event on the application instance
        // When the event is triggered, the popupAdd component is displayed
        this.on(this.app, 'addCode:button', (filter) => {
            popupAdd.show(); // Show the popup for adding code
        });

        // Bind the editForm element to the datatable element for data manipulation
       $$('editForm').bind($$('datatable')); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
